module.exports = __webpack_public_path__ + "img/icon-empty.a4b7cc0d.svg";